import React from 'react';
import { Investment } from '@/types/investment';

interface InvestmentDetailHeroProps {
  investment: Investment;
}

const InvestmentDetailHero: React.FC<InvestmentDetailHeroProps> = ({ investment }) => {
  return (
    <div className="bg-navy-dark text-primary-foreground py-16 sm:py-20">
      <div className="container">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 md:gap-12 items-center">
          <div className="md:col-span-2">
            <p className="text-base font-semibold uppercase tracking-widest text-bronze-gold mb-4">{investment.category}</p>
            <h1 className="text-4xl lg:text-5xl font-bold mb-4">{investment.name}</h1>
                      </div>
          <div className="mt-6 md:mt-0">
            <div className="flex flex-wrap gap-3 justify-start md:justify-end">
  {investment.tags.map(tag => (
    <span key={tag} className="px-4 py-2 text-sm font-medium bg-white text-[hsl(var(--navy))] rounded-full border border-bronze-gold/50">
  {tag}
</span>
  ))}
</div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default InvestmentDetailHero;
